/** Запросы к серверу. Все адреса относительные: интерфейс и сервер работают на одном адресе. */
import { onUnauthorized } from './auth';

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number
  ) {
    super(message);
  }
}

async function request<T>(method: 'GET' | 'POST' | 'PUT' | 'DELETE', url: string, body?: unknown, allowStatus: number[] = []): Promise<T> {
  let res: Response;
  try {
    res = await fetch(url, {
      method,
      headers: {
        Accept: 'application/json',
        ...(body !== undefined ? { 'Content-Type': 'application/json' } : {})
      },
      body: body !== undefined ? JSON.stringify(body) : undefined
    });
  } catch {
    throw new ApiError('Сервер не отвечает. Проверьте подключение к интернету или попробуйте позже.', 0);
  }
  // Сессия закончилась — вернуть на экран входа
  if (res.status === 401 && !url.startsWith('/api/auth/')) onUnauthorized();
  if (!res.ok && !allowStatus.includes(res.status)) {
    let message = `Ошибка сервера (${res.status})`;
    try {
      const data = (await res.json()) as { error?: string; message?: string };
      message = data.error ?? data.message ?? message;
    } catch {
      /* ответ не JSON — оставляем общее сообщение */
    }
    throw new ApiError(message, res.status);
  }
  return (await res.json()) as T;
}

export function getJson<T>(url: string, opts: { allowStatus?: number[] } = {}): Promise<T> {
  return request<T>('GET', url, undefined, opts.allowStatus);
}

export function postJson<T>(url: string, body: unknown = {}): Promise<T> {
  return request<T>('POST', url, body);
}

export function putJson<T>(url: string, body: unknown = {}): Promise<T> {
  return request<T>('PUT', url, body);
}

export function requestDelete<T>(url: string): Promise<T> {
  return request<T>('DELETE', url);
}

/** Отправка файлов (multipart). */
export async function postForm<T>(url: string, form: FormData): Promise<T> {
  let res: Response;
  try {
    res = await fetch(url, { method: 'POST', headers: { Accept: 'application/json' }, body: form });
  } catch {
    throw new ApiError('Сервер не отвечает. Проверьте подключение к интернету или попробуйте позже.', 0);
  }
  if (!res.ok) {
    let message = `Ошибка сервера (${res.status})`;
    try {
      const data = (await res.json()) as { error?: string; message?: string };
      message = data.error ?? data.message ?? message;
    } catch {
      /* ответ не JSON */
    }
    throw new ApiError(message, res.status);
  }
  return (await res.json()) as T;
}

export function errorText(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}
